import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import Box from "@mui/material/Box";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import { errorToast, successToast } from "../../helpers/toast";
import SearchBar2 from "../../components/SearchBar2";
import { isValidInput } from "../../utils/validation";
import Pagination from "../../components/Pagination";
import WarnModal from "../../components/WarnModal";
import Loader from "../../helpers/constants/Loader";

import { PropertyType } from "../../types/General";
import { useDeleteByIdpropertyStatusMutation, useGetAllpropertyStatusQuery } from "../../services/propertyStatus";
import EditKeyModal from "../../components/EditWarnModal";
const ManagePropertyStatus = () => {

  const navigate = useNavigate();

  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<number>(0);
  const [openEdit, setOpenEdit] = useState<boolean>(false);
  const [rows, setRows] = useState<PropertyType[]>([]);
  const [deleteType] = useDeleteByIdpropertyStatusMutation();
  const [isLoading, setIsLoading] = useState<boolean>(false)




  const { isError, data, isSuccess, isLoading: load } = useGetAllpropertyStatusQuery({
    search: searchTerm
  })


  const handleDelete = async (userId: any) => {
    setIsLoading(true)
    try {
      const response = await deleteType({ userId }).unwrap();
      if (response?.statusCode === 200) {
        successToast("Property Status deleted successfully");
      }
      setIsLoading(false)
    } catch (error: any) {
      setIsLoading(false)
      console.error(error);
      errorToast(error?.message || error?.data?.message || "");
    }
  };

  const naviagteFun = () => {
    navigate(`/manage-propertyStatus/edit/${selectedId}`)
  }

  useEffect(() => {
    if (isSuccess && data) {
      const res = data?.data;
      setRows(res?.PropertyCondition || []);

    }
  }, [isSuccess, data]);


  return (
    <div>
      <div className="main_loyout">
        <Loader isLoad={isLoading || load} />
        <div className="dashboard">
          <h1 className="mn_hdng">Manage Property Status</h1>
        </div>
        <Card className="cards">
          <Box className="cards_header">
            <SearchBar2
              value={searchTerm}
              searchTerm={searchTerm}
              onCross={() => setSearchTerm("")}
              setDebouncedSearchTerm={setDebouncedSearchTerm}
              onChange={(val: any) => {
                if (isValidInput(val.target.value)) {
                  setSearchTerm(val.target.value);

                }
              }}
            />

            <Box className="cards_header_right">

              <Button
                className="btn btn_primary"
                onClick={() => {
                  navigate("/manage-propertyStatus/add");
                }}
              >
                <AddIcon />
                Add Property Status
              </Button>
            </Box>
          </Box>
          <TableContainer className="table_container">
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">S.No</TableCell>

                  <TableCell>Property Status</TableCell>
                  {/* <TableCell>Tokens</TableCell> */}

                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows?.length == 0 ? (<TableRow>
                  <TableCell colSpan={12} align="center">
                    No property status found
                  </TableCell>
                </TableRow>) :
                  (rows.map((row: any, index: any) => (
                    <TableRow key={row?._id}>
                      <TableCell align="center">{index + 1}</TableCell>

                      <TableCell>{row?.name || "-"}</TableCell>
                      {/* <TableCell>{row?.settings?.token || '-'}</TableCell> */}

                      <TableCell>
                        <Box className="table_actions">

                          <Tooltip title="Edit details">
                            <IconButton
                              // onClick={() =>
                              //   navigate(`/manage-propertyStatus/edit/${row?._id}`)
                              // }
                              onClick={() => {
                                setOpenEdit(true);
                                setSelectedId(row?._id);
                              }}
                            >
                              <ModeEditIcon />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Delete">
                            <IconButton onClick={() => {
                              setOpen(true);
                              setSelectedId(row?._id);
                            }}>
                              <DeleteIcon />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </TableCell>
                    </TableRow>
                  )))}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
      </div>
      <EditKeyModal
        open={openEdit}
        setOpen={setOpenEdit}
        navigate={naviagteFun}
      />
      <WarnModal
        open={open}
        setOpen={setOpen}
        handleDelete={() => handleDelete(selectedId)}
        name="Property Status"
      />
    </div>
  );
};

export default ManagePropertyStatus;
